import React from 'react';
import { StudyEvaluationSP } from '../models/StudyEvaluation';

export default function StudyEvaluationSummary(list:any) {

    const data:StudyEvaluationSP[] = list.data;

    const level =  window.localStorage.getItem('LEVEL_ID');

    const renderData = () => {
        return data.map((item, index) => {
          return (
                <React.Fragment>
                    <tr key={index}>
                        <td>{item.WARNING_LETTER}</td>
                        <td>{Number(item.TOTAL) - Number(item.PROCESSED)}</td>
                        <td>{item.PROCESSED}</td>
                        <td>{item.TOTAL}</td>
                    </tr>
                </React.Fragment>
            );
        })
    }

    return (
        <React.Fragment>
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">Summary Study Evaluation Process</h3>
                        </div>
                        <div className="card-body table-responsive p-0">
                            <div className="col-12">
                                <table className="table table-hover text-nowrap">
                                    <thead>
                                        <tr>
                                            <th>Warning Letter</th>
                                            <th>On Progress</th>
                                            <th>Processed</th>
                                            <th>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        { renderData() }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}